// Samples.js
import React, { useState } from 'react';

const services = [
  {
    title: 'Essay Help',
    description: 'Get the best assistance with all essay genres – descriptive, analytical, and more.'
  },
  {
    title: 'Homework Help',
    description: 'From K12 to post doctorate – we offer aid with homework for all academic levels.'
  },
  {
    title: 'Dissertation Help',
    description: 'Our experts are here to help you at every stage of the dissertation writing process.'
  },
  {
    title: 'Coursework Help',
    description: 'Submit coursework on time with quality guidance from our subject matter experts.'
  },
  {
    title: 'Essay Typer',
    description: 'Simplify the task with topic suggestions and data-driven content from our tool.'
  },
  {
    title: 'Plagiarism Checker',
    description: 'Check your academic papers for duplicate text using our free and advanced tool.'
  },
  {
    title: 'Paraphrasing Tool',
    description: 'Restructure sentences accurately without altering the meaning with our free tool.'
  },
  {
    title: 'Conclusion Writing',
    description: 'Leave a lasting impression on readers with conclusions churned by our academic experts.'
  }
];

const faqs = [
  {
    question: 'Can online essay samples be customized for specific requirements?',
    answer: 'Absolutely! Online essay samples can be tailored to meet individual academic needs. They serve as flexible templates that allow students to integrate their own ideas and meet assignment-specific guidelines.'
  },
  {
    question: 'Are there risks associated with relying too heavily on online essay samples?',
    answer: 'Yes. Overdependence can lead to copying structures or ideas without true understanding. It’s important to use them as references to build your own insights.'
  },
  {
    question: 'How can students avoid the misuse of online assignment samples?',
    answer: 'Students should treat samples as guides. Focus on learning the techniques and concepts shown rather than directly reusing the content. Always cite the original sources when necessary.'
  },
  {
    question: 'Are there any ethical concerns regarding the use of online essay samples?',
    answer: 'Ethical concerns may arise if students submit copied content. To maintain academic integrity, samples should only be used for reference and learning—not as final submissions.'
  },
  {
    question: 'What are online essay samples, and how can they benefit students?',
    answer: 'These are pre-written academic examples that offer insights into structure, tone, and style. They help students improve their writing by showcasing academic standards and expectations.'
  },
  {
    question: 'Are online essay samples considered plagiarism if used as a reference?',
    answer: 'No, referencing is acceptable. However, copying without citation is plagiarism. Use samples to understand formatting and logic, and always cite if content is reused.'
  },
  {
    question: 'Where can students find reliable online essay samples?',
    answer: 'Trusted education platforms like Infinite Solution offer quality samples. University libraries and seniors are also great sources of academic material.'
  },
  {
    question: 'How can online essay samples help improve writing skills?',
    answer: 'They act as educational tools that demonstrate how to build arguments, organize content, and format papers. Analyzing samples can significantly boost writing confidence and proficiency.'
  }
];

const Samples = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-[#02042b] text-white py-16 px-4 mt-20">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl font-bold text-center mb-4">Get Comprehensive Assignment Help Services</h1>
        <p className="text-center text-lg mb-12 text-gray-300">We have the best minds and resources for you!</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mb-20">
          {services.map((service, index) => (
            <div key={index} className="bg-white text-gray-900 rounded-2xl p-6 shadow hover:shadow-lg transition-all duration-300">
              <h3 className="font-bold text-xl mb-2">{service.title}</h3>
              <p className="text-sm leading-relaxed">{service.description}</p>
            </div>
          ))}
        </div>

        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl font-semibold text-center mb-8">Frequently Asked Questions</h2>
          <div className="space-y-4">
            {faqs.map((faq, idx) => (
              <div key={idx} className="bg-white text-black rounded-xl shadow-md">
                <button
                  onClick={() => toggleFAQ(idx)}
                  className="w-full text-left px-6 py-4 font-semibold text-lg flex justify-between items-center"
                >
                  {faq.question}
                  <span>{activeIndex === idx ? '−' : '+'}</span>
                </button>
                {activeIndex === idx && (
                  <div className="px-6 pb-4 text-sm leading-relaxed">
                    {faq.answer}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

      </div>
    </div>
  );
};

export default Samples;